import Sifter from "../../../vendor/assets/javascripts/selectize/sifter";
globalThis.Sifter = Sifter;
